<script>
/*eslint-disable */
import NProgress from "nprogress";
import Axios from "axios";
import Email from "../../../components/auth/Email.vue";

export default {
    name: "ForgotDefault",
    components: {
        Email
    },
    data() {
        return {
            userEmail: "",
            isCheckEmail: true
        };
    },
    methods: {
        sendForgotRequest() {
            NProgress.start();
            Axios({url: '/ir/auth/forgot/username', data: {email: this.userEmail}, method: 'POST'})
                .then(resp => {
                    this.isCheckEmail = !(resp && resp.data && resp.data.status === false);
                    if (this.isCheckEmail) this.$router.push('/login');
                })
                .catch(err => {
                    console.log(err);
                }).finally(() => {
                NProgress.done();
            });
        },
        goToHome() {
            document.location.replace(appConfig.homeURL + '/');
            // this.$router.push('/');
        },
    }
};
</script>

<template>
    <div class="container-fluid page">
        <div class="content">
            <div class="background column">
                <img src="../../../assets/img/login-background.jpg" alt="partsearch"/>
            </div>
            <div class="form-container column">
                <div class="form">
                    <div class="auth-header">
                        <div class="logo">
                            <div @click.prevent="goToHome" class="logo-text">
                                <img src="../../../assets/logos/partssearch-logo-white-backgroud.svg" class="auth-logo-svg"/>
                            </div>
                        </div>
                        <span class="close" @click="$router.push('/')">×</span>
                    </div>
                    <form method="POST">
                        <h2 class="header-text">Forgot your Username?</h2>
                        <p>Dont’ worry, just enter the email address your account is registered with and we will send you
                            your username</p>
                        <br/>
                        <div class="form-group">
                            <label for="userEmail">Email Address</label>
                            <email v-model="userEmail"></email>
                            <p>
                                Get Help with your username.
                                <router-link :to="{name: 'SupportUserNamePage'}">Click here</router-link>
                            </p>
                        </div>

                        <div class="form-group">
                            <button :disabled="!isCheckEmail || !userEmail"
                                    type="button"
                                    @click="sendForgotRequest"
                                    class="btn input-btn">Send Me My Username
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
@import "../../../styles/login/style.css";
</style>

<style scoped>
    .page {
        height: 100vh;
    }

    @media screen and (max-width: 768px) {
        .page .content {
            height: 100%;
        }
        .page .content .form-container {
            height: 100%;
        }
        .page .form {
            height: 100%;
        }
        .page .form form {
            display: flex;
            flex-direction: column;
            height: 80%;
            justify-content: center;
        }
    }
</style>
